export default function AmbientOrb() {
  return (
    <div className="hidden dark:contents" aria-hidden="true">
      <div
        className="pointer-events-none fixed left-0 top-0 z-0 rounded-full"
        style={{
          width: '260vw',
          height: '260vw',
          transform: 'translate(-50%, -50%)',
          filter: 'blur(90px)',
          background:
            'radial-gradient(circle, rgba(24,62,246,0.38) 0%, rgba(24,62,246,0.26) 14%, rgba(24,62,246,0.16) 28%, rgba(24,62,246,0.09) 42%, rgba(24,62,246,0.04) 56%, rgba(24,62,246,0.015) 68%, rgba(24,62,246,0) 82%)',
        }}
      />
      <div
        className="pointer-events-none fixed left-0 top-0 z-0 rounded-full"
        style={{
          width: '110vw',
          height: '110vw',
          transform: 'translate(-50%, -50%)',
          filter: 'blur(70px)',
          background:
            'radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(24,62,246,0.10) 22%, rgba(24,62,246,0.05) 42%, rgba(24,62,246,0.015) 62%, rgba(24,62,246,0) 80%)',
        }}
      />
    </div>
  );
}
